import React from 'react';
import { ProductSection } from '../../sections';

const ProductContainer = () => {
  return (
    <div>
      <ProductSection />
    </div>
  );
};

export default ProductContainer;
